import { getApi } from "../../services/httpService";


export function gallery(){
    return getApi().get('home/gallery');
}